import BasePortableText from '@sanity/block-content-to-react';
import classNames from 'classnames';
import React from 'react';

import clientConfig from '../../../client-config';
import { serializers } from './serializers';

export function BarebonesPortableText({ blocks, className }) {
	return (
		<BasePortableText
			blocks={blocks}
			className={classNames(className, 'barebones-portable-text-container')}
			renderContainerOnSingleChild={true}
			serializers={serializers}
			{...clientConfig.sanity}
		/>
	);
}
